module.exports = __webpack_public_path__ + "static/media/galway.d53248e6.png";